import { getDetailHeadData } from "~/components/blocks/product/util/get-detail-head-data";
import type { Queries } from "~/const/hrefs";
import type { G_GetVideoQuery } from "~/lib/graphql";

type OpenShareDialogArgs = {
  videoData: G_GetVideoQuery["video"];
  spot?: Queries["spot"];
};

export const openShareDialog = async ({ videoData, spot }: OpenShareDialogArgs) => {
  const { ogpTitle, ogpDescription, aiadDetailBackUrl } = getDetailHeadData({
    videoData,
    spot,
  });

  const detailShareUrl = `https://rcv.ixd.dmm.com/api/surl?urid=kIGziUoN&lurl=${aiadDetailBackUrl}`;

  try {
    await navigator.share({ title: ogpTitle, text: ogpDescription, url: detailShareUrl });
  } catch (error) {
    console.error(error);
  }
};
